import React, { Component, Fragment } from "react";
import api from "../../../../../services/api";
import { Link } from "react-router-dom";
import UploadArquivo from "../Arquivo/index"
import { Toast } from "bootstrap";

export default class UploadIndex extends Component {

    constructor(props) {
        super(props);

        this.state = {
            planilhas: [],
            isLoaded: false
        }

    }

    async componentDidMount() {
        this.atualizaDados();
    }

    atualizaDados = async () => {
        let planilhas = await this.getDados();
        planilhas = planilhas.data.planilhas
        this.setState({ planilhas });
    }

    getDados = async () => {
        return await api.get("/sti/upload");
    }

    excluirPlanilha = async (planilha) => {
        let status = await api.delete("/sti/upload", { data: { planilha } });
        alert(status.data.status)
        this.atualizaDados();
    }

    atualizarBaseAposUploadPlanilhas = async () => {
        this.setState({ isLoaded: true });
        let status = await api.get("/sti/atualizar");
        this.setState({ isLoaded: false });
        alert(status.data.msg)
    }

    fazerDownloadPlanilha = async () => {
        let status = await api.get("/sti/download");
        //var blob = new Blob([status.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        //FileSaver.saveAs(blob, "fileName.xlsx");
    }

    render() {
        let { planilhas, isLoaded } = this.state;
        return (
            <Fragment>

                <div className="card">
                    <div className="card-header">
                        Carregar Planilhas
                    </div>
                    <div className="card-body">

                        <Link to={location => (
                            {
                                ...location,
                                pathname: `/`,
                                anterior: window.location.pathname || "/unidade",
                            }
                        )}>
                            <button className="btn btn-primary btn-sm">Voltar</button>
                        </Link>

                        <div className="row mt-3">

                            <div className="card col-4">
                                <div className="card-body">
                                    <table className="table table-sm table-hover" >
                                        <thead>
                                            <tr>
                                                <th>Planilha</th>
                                                <th>Ação</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {planilhas.map((nome, i) => {
                                                return (
                                                    <tr>
                                                        <td>{nome}</td>
                                                        <td>
                                                            <button className="btn btn-outline-danger btn-sm" onClick={() => this.excluirPlanilha(nome)}>Excluir</button>
                                                            <a href={`http://10.10.8.49:3000/download?mes=${nome}`} target="_black"><button className="btn btn-outline-success btn-sm">Download</button></a>
                                                        
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            
                            <div className="card col-8">
                                <div className="card-body">
                                    <UploadArquivo atualizaDados={this.atualizaDados} />
                                </div>
                            </div>

                        </div>

                        <hr />

                        <div className="text-center">
                            <div>
                                <button className="btn btn-success mx-auto" onClick={this.atualizarBaseAposUploadPlanilhas}>
                                    { isLoaded && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> } Atualizar Dados
                                </button>
                            </div>
                        </div>

                        <hr />

                    </div>
                </div>

            </Fragment>
        )
    }
}